<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<app-i-ching></app-i-ching>

